export const activityDetails = [
    {  
		checkbox: true,
		title: "We scheduled a meeting for next week",
		activity_type: "Meeting",
		due_date:"16/01/2024",
		owner: "Hendry",
		created_date:"14/01/2024",
        key:1
	},
	{   
		checkbox: true,
		title: "Had conversation with Fred regarding task",
		activity_type: "Calls",
		due_date:"24/01/2024",
		owner: "Guilory",
		created_date:"21/01/2024",
        key:2
	},
	{
		checkbox: true,
		title: "Analysing latest time estimation for new project",
		activity_type: "Tasks",
		due_date:"23/02/2024",
		owner: "Jami",
		created_date:"20/02/2024",
        key:3
	},
	{
		checkbox: true,
		title: "Store and manage contact data",
		activity_type: "Email",
		due_date:"18/03/2024",
		owner: "Theresa",
		created_date:"15/03/2024",
        key:4
	},
	{
		checkbox: true,
		title: "Call John and discuss about project",
		activity_type: "Calls",
		due_date:"14/04/2024",
		owner: "Smith",
		created_date:"12/04/2024",
        key:5
	},
	{
		checkbox: true,
		title: "Will have a meeting before project start",
		activity_type: "Meeting",
		due_date:"22/05/2024",
		owner: "Martin",
		created_date:"20/05/2024",
        key:6
	},
	{
		checkbox: true,
		title: "Will have a meeting before project start",
		activity_type: "Meeting",
		due_date:"22/05/2024",
		owner: "Martin",
		created_date:"20/05/2024",
        key:7
	},
	{
		checkbox: true,
		title: "Built landing pages",
		activity_type: "Email",
		due_date:"08/07/2024",
		owner: "Newell",
		created_date:"06/07/2024",
        key:8
	},
	{
		checkbox: true,
		title: "Discussed budget proposal with Edwin",
		activity_type: "Calls",
		due_date:"05/09/2024",
		owner: "Janet",
		created_date:"02/09/2024",
        key:9
	},
	{
		checkbox: true,
		title: "Attach final proposal for upcoming project",
		activity_type: "Tasks",
		due_date:"18/11/2024",
		owner: "Craig",
		created_date:"15/11/2024",
        key:10
	}
];
